import { triggerLinkView } from '@micro-apps/env';

// Same event name as the Web integration so Tealium routes it to the same `list1` mapping.
export const OPTIMIZELY_DECISION_EVENT_NAME = 'OptimizelyLayerDecision';

export function sendToAdobe(experimentName: string): void {
	triggerLinkView(OPTIMIZELY_DECISION_EVENT_NAME, { experiment_name: experimentName });
}
